(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maison-colorway-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maison-colorway-preview')) {
  customElements.define('maison-colorway-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.picker = this.closest('[data-variant-picker]');
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('.mc-palette-open');
      this.openButton.addEventListener('click', () => this.dialog.showModal(), opts);
      this.querySelector('.mc-palette-close').addEventListener('click', () => this.dialog.close(), opts);
      this.dialog.addEventListener('close', () => this.openButton.focus({preventScroll:true}), opts);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, opts);
      this.picker?.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][name="Colorway"]')) this.updatePalette(event.target);
      }, {...opts, capture:true});
      const selected = this.picker?.querySelector('input[name="Colorway"]:checked');
      if (selected) this.updatePalette(selected);
    }
    updatePalette(input) {
      const image = input.closest('.variant-picker__option')?.querySelector('label img');
      if (!image) return;
      this.querySelectorAll('[data-palette-image]').forEach(img => {
        img.src = image.src;
        img.alt = input.value;
      });
      this.querySelectorAll('[data-palette-name]').forEach(el => el.textContent = input.value);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maison-menorah-colors"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('maison-menorah-colors')){
  customElements.define('maison-menorah-colors',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.controller=new AbortController();
      this.picker=this.closest('[data-variant-picker]');
      const update=()=>{
        const selected=this.picker?.querySelector('input[name="Colorway"]:checked,select[name="options[Colorway]"],select[data-option-name="Colorway"]');
        this.updatePalette(selected?.value||this.dataset.selected);
      };
      this.picker?.addEventListener('change',event=>{
        if(event.target.matches('input[name="Colorway"],select[name="options[Colorway]"],select[data-option-name="Colorway"]'))this.updatePalette(event.target.value);
      },{capture:true,signal:this.controller.signal});
      window.addEventListener('popstate',()=>requestAnimationFrame(update),{signal:this.controller.signal});
      update();
    }
    updatePalette(name){
      const panels=Array.from(this.querySelectorAll('[data-colorway-palette]'));
      const found=panels.find(panel=>panel.dataset.colorwayPalette===name);
      if(!found){this.hidden=true;return;}
      this.hidden=false;
      panels.forEach(panel=>panel.hidden=panel!==found);
      this.querySelector('[data-colorway-name]').textContent=name;
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maison-wave-colors"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('maison-wave-colors')){
  customElements.define('maison-wave-colors',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.controller=new AbortController();
      this.picker=this.closest('[data-variant-picker]');
      const update=()=>{
        const selected=this.picker?.querySelector('input[name="Colorway"]:checked');
        this.updatePalette(selected?.value||this.dataset.selected);
      };
      this.picker?.addEventListener('change',event=>{
        if(event.target.matches('input[name="Colorway"],select[name="options[Colorway]"]'))this.updatePalette(event.target.value);
      },{capture:true,signal:this.controller.signal});
      window.addEventListener('popstate',()=>requestAnimationFrame(update),{signal:this.controller.signal});
      update();
    }
    updatePalette(name){
      const panels=Array.from(this.querySelectorAll('[data-wave-palette]'));
      const found=panels.find(panel=>panel.dataset.wavePalette===name);
      if(!found){this.hidden=true;return;}
      this.hidden=false;
      panels.forEach(panel=>panel.hidden=panel!==found);
      this.querySelector('[data-wave-name]').textContent=name;
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
